import React from 'react';
import { cn } from '@/lib/utils';

/**
 * GlassSurface — el vidrio esmerilado de VONDI (BRAND.md §3, manual §11).
 *
 * "Blanco a 55–90% de opacidad, blur 8–16px, borde blanco 1.5px, brillo interior
 * superior, esquinas muy redondeadas."
 *
 * Regla de oro del manual, que este componente no puede hacer cumplir solo:
 * el vidrio siempre va sobre fondo claro o con color/foto detrás, para que se
 * lea la translucidez. Y no se abusa del blur en textos largos — es para
 * contenedores, chips e íconos.
 *
 * Reemplaza el patrón que hoy está copiado a mano en ~14 lugares
 * (Benefits.jsx, Home.jsx, CloserPanel.jsx, LandingNavbar.jsx…).
 */
export function GlassSurface({
  /** Opacidad del blanco. El manual la acota a 55–90%. */
  opacity = 0.82,
  /** Radio del desenfoque en px. El manual lo acota a 8–16px. */
  blur = 14,
  /** Elemento a renderizar. */
  as: Tag = 'div',
  className = '',
  style = {},
  children,
  ...rest
}) {
  const o = Math.min(0.9, Math.max(0.55, opacity));
  const b = Math.min(16, Math.max(8, blur));

  return (
    <Tag
      className={cn('rounded-card', className)}
      style={{
        background: `rgba(255, 255, 255, ${o})`,
        backdropFilter: `blur(${b}px)`,
        WebkitBackdropFilter: `blur(${b}px)`,
        border: '1.5px solid rgba(255, 255, 255, 0.75)',
        /* Brillo interior superior + sombra cálida (nunca gris fría) */
        boxShadow:
          'inset 0 1px 0 0 rgba(255, 255, 255, 0.65), 0 8px 32px -8px rgba(250, 77, 10, 0.16)',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default GlassSurface;
